module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAAHhSr/lAAAAAXNSR0IArs4c6QAAAKtJREFUSA3tlbsNgDAMRBNEwRh0jMHytGzCCgionafIQQdyEboc/tydg8nnPl3JPOO4rQZKKR/zUkTmD9KLzg+AjCgQWWIgMbeBgwXo7OLmquQi76vkUUdiCHN1pETCXG5RImFSZi73iQVhWmZhpymVKS0W955JZUqLxf0CpDKlxfAPSBvhb0yqUkm+E2t1U7rLWpvX4vsoa+7Qu7COSXc/KX+LhXWsE2sd6Q2qLCqhQaj4MgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Lithuania.png
// module id = 478
// module chunks = 7